<template>
  <v-app>
    <v-container fluid class="fill-height">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="6" md="3">
          <validation-observer
            ref="observer"
            v-slot="{ invalid }"
            tag="form"
          >
            <v-form>
              <v-card class="elevation-12">
                <v-toolbar v-if="showAction" :color="color" dark flat>
                  <v-toolbar-title>Authorization</v-toolbar-title>
                  <v-spacer/>
                </v-toolbar>
                <v-alert v-if="alert.success" type="success">{{ alert.success }}</v-alert>
                <v-alert v-if="alert.error" type="error">{{ alert.error }}</v-alert>
                <v-card-text v-if="showAction">
                  <validation-provider v-slot="{ errors }" name="email" rules="required|email|min:6|max:36">
                    <v-text-field
                      v-model="form.email"
                      name="email"
                      :error-messages="errors"
                      prepend-icon="fa-user"
                      type="email"
                      required
                      autofocus
                    />
                  </validation-provider>
                  <validation-provider v-slot="{ errors }" name="password" rules="required|min:4|max:18">
                    <v-text-field
                      v-model="form.password"
                      :counter="0"
                      name="password"
                      :error-messages="errors"
                      prepend-icon="fa-key"
                      type="password"
                      required
                    />
                  </validation-provider>
                </v-card-text>
                <v-card-actions class="justify-center pt-0 pb-5" v-if="showAction">
                  <v-btn :loading="loading" :disabled="invalid" @click="submit" :color="color">Login</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </validation-observer>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import '@/validate'

setInteractionMode('eager')

export default {
  name: 'Login',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data: () => ({
    alert: {
      success: '',
      error: ''
    },
    loading: false,
    showAction: true,
    color: 'primary',
    form: {
      email: '',
      password: ''
    }
  }),
  methods: {
    async submit () {
      const isValid = await this.$refs.observer.validate()

      if (isValid) {
        const payload = {
          email: this.form.email,
          password: this.form.password
        }

        const response = await this.$store.dispatch('login', payload)
        console.log(response)
        this.loading = false

        if (response.data.error) {
          this.alert.error = response.statusText
        } else {
          this.showAction = false
          this.alert.success = 'You are logged in'
          setTimeout(() => this.$router.push({ name: 'dashboard' }), 2000)
        }

        this.form.email = ''
        this.form.password = ''
        this.$refs.observer.reset()
      }
    }
  }
}
</script>
